import React, { memo } from 'react';
import clsx from 'clsx';
import { normalizeForSearch } from '../utils/searchUtils';

interface PrimitiveValueProps {
    value: any;
    searchPath: string | null;
}

/**
 * Component for rendering primitive values
 * @param props - Component props
 * @returns Rendered component
 */
const PrimitiveValue = memo(({ value, searchPath }: PrimitiveValueProps) => {
    const stringValue = String(value);
    const isMatch =
        searchPath &&
        normalizeForSearch(stringValue).includes(
            normalizeForSearch(searchPath),
        );

    return (
        <span className={clsx(isMatch && 'text-green font-thin')}>
            {typeof value === 'string' ? `"${stringValue}"` : stringValue}
        </span>
    );
});

export default PrimitiveValue;
